<template>
  <div class="container-fluid vehicle-info-container px-0 pt-4 pb-2 pb-sm-4">
    <div class="smaller-container-wrapper">
      <p v-if="vehiclePrice" class="text-white my-0">{{ $n(vehiclePrice, 'currencyDollars', languageCode) }}</p>
      <h2 class="text-white mt-3 mb-0">{{ vehicleString }}</h2>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'VehicleInformation',
  computed: {
    ...mapGetters('vehicle', ['vehicleString']),
    ...mapGetters({
      languageCode: 'user/getLanguageCodeForNumericalInternationalization',
    }),
    vehiclePrice() {
      // TODO: Enable the price when we have a correct vehicle price logic for Spotlight
      return null;
      // return this.$route.query.purchasePrice || null;
    },
  },
};
</script>

<style scoped lang="scss">
@import 'src/assets/scss/variables';
.vehicle-info-container {
  background-color: $primary;
  .smaller-container-wrapper {
    padding: 0 20px;
  }
}
</style>
